import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ReferencementPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

function ReferencementPage() {
    const navigate = useNavigate();

    return (
        <div className="referencement-page">
            <Header />

            {/* Wrapper containing octopus that spans multiple sections */}
            <div className="referencement-octopus-wrapper">
                {/* Hero Section */}
                <section className="referencement-hero">
                    <div className="referencement-hero-wrapper">
                        <div className="referencement-hero-container">
                            <h1 className="referencement-hero-title">
                                Référencement &amp; Rédaction SEO assistés par <span className="referencement-hero-highlight">Intelligence Artificielle</span>
                            </h1>
                            <p className="referencement-hero-text">
                                Chez Viviworks.AI, nous redéfinissons le référencement naturel en y intégrant la puissance de l'intelligence artificielle.
                            </p>
                            <p className="referencement-hero-text">
                                Grâce à des outils d'analyse avancés, des modèles prédictifs et une rédaction optimisée par l'IA, nous créons des stratégies SEO capables d'anticiper les tendances et d'amplifier votre visibilité en ligne.
                            </p>

                            <button className="referencement-hero-button" onClick={() => navigate('/#contact')}>
                                Contactez nous directement
                            </button>
                        </div>

                        <div className="referencement-hero-image-right">
                            <img src="/slide1Q.png" alt="IA Octopus" className="referencement-hero-octopus" />
                        </div>
                    </div>
                </section>

                {/* Audit SEO Intelligent */}
                <section className="referencement-service-section">
                    <div className="referencement-service-wrapper">
                        <div className="referencement-service-container">
                            <h2 className="referencement-service-title">
                                Audit SEO <span className="referencement-service-highlight">intelligent</span>
                            </h2>
                            <p className="referencement-service-text">
                                Avant toute action, nous commençons par un audit SEO intelligent, propulsé par des technologies d'intelligence artificielle.
                            </p>
                            <p className="referencement-service-text">
                                Nos outils analysent en profondeur votre site, décodent vos forces et vos faiblesses et décortiquent chaque levier de performance secondaire : structure, contenus, backlinks, performance mobile, UX et point-clés du SEO technique.
                            </p>
                            <p className="referencement-service-text">
                                L'IA nous aide à repérer des insights invisibles à l'œil nu, à évaluer la concurrence et à cartographier la structure digitale pour vous offrir une feuille de route SEO ultra précise.
                            </p>
                            <p className="referencement-service-text">
                                Résultat : une stratégie tissée, mesurable, et parfaitement calibrée pour vos objectifs de croissance.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Rédaction de contenu optimisé IA */}
                <section className="referencement-service-section">
                    <div className="referencement-service-wrapper">
                        <div className="referencement-service-container">
                            <h2 className="referencement-service-title">
                                Rédaction de contenu <span className="referencement-service-highlight">optimisé IA</span>
                            </h2>
                            <p className="referencement-service-text">
                                Notre rédaction web combine la créativité humaine avec la précision de l'intelligence artificielle pour produire des contenus qui vous interrogeant et performants.
                            </p>
                            <p className="referencement-service-text">
                                Grâce à l'analyse sémantique automatisée, nous identifions les stratégies lexicales les plus pertinentes, adaptons le ton et la lisibilité et à ajustons les contenus originaux, riches en éléments et synthétiquement optimisées pour les audiences.
                            </p>
                            <p className="referencement-service-text">
                                L'IA accompagne chaque étape du processus créatif : de la recherche de mots-clés à la création de titres attractifs en passant par la construction de structures textuelles parfaites.
                            </p>
                            <p className="referencement-service-text">
                                Chaque texte est conçu pour séduire les visiteurs de plus en plus exigeants et à séduits les moteurs de recherche.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Stratégie de contenu prédictive */}
                <section className="referencement-service-section">
                    <div className="referencement-service-wrapper">
                        <div className="referencement-service-container">
                            <h2 className="referencement-service-title">
                                Stratégie de contenu <span className="referencement-service-highlight">prédictive</span>
                            </h2>
                            <p className="referencement-service-text">
                                L'analyse et l'étude predictif jouent un rôle clés dans les SEO moderne.
                            </p>
                            <p className="referencement-service-text">
                                Grâce à l'analyse prédictive, nous identifions les tendances de recherche émergentes, les topic porteurs et les intentions d'utilisateurs avant qu'ils ne deviennent populaires.
                            </p>
                            <p className="referencement-service-text">
                                Nous construisons avec des stratégies de contenus anticipatives, capables de performer avant vos critiques comme référence sur votre marché et avec une visibilité renforcée sur le long terme.
                            </p>
                            <p className="referencement-service-text">
                                Notre approche de planifier assiste non seulement de créer comme organiquement durable et une stratégie renforcée dès le long terme.
                            </p>

                            <button className="referencement-service-button" onClick={() => navigate('/#contact')}>
                                Commencez votre audit
                            </button>
                        </div>
                    </div>
                </section>
            </div>

            {/* CTA Final */}
            <section className="referencement-cta">
                <div className="referencement-cta-container">
                    <h2 className="referencement-cta-title">
                        Donnez à votre visibilité en ligne une intelligence nouvelle
                    </h2>
                    <p className="referencement-cta-text">
                        Avec Viviworks.AI, votre stratégie de référencement devient proactive, personnalisée et mesurable.
                    </p>
                    <p className="referencement-cta-text">
                        Grâce à la puissance de l'intelligence artificielle, nous faisons un vous assasons une méthode sur véritablement mesure pour performer vos performances et la conversion.
                    </p>
                </div>
            </section>

            <Footer />
            <ScrollToTop />
        </div>
    );
}

export default ReferencementPage;
